const BYTE_TO_HEX = Array.from({ length: 256 }, (_, index) =>
  index.toString(16).padStart(2, '0')
);

function uuidFromRandomBytes(bytes: Uint8Array) {
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  return (
    BYTE_TO_HEX[bytes[0]] +
    BYTE_TO_HEX[bytes[1]] +
    BYTE_TO_HEX[bytes[2]] +
    BYTE_TO_HEX[bytes[3]] +
    '-' +
    BYTE_TO_HEX[bytes[4]] +
    BYTE_TO_HEX[bytes[5]] +
    '-' +
    BYTE_TO_HEX[bytes[6]] +
    BYTE_TO_HEX[bytes[7]] +
    '-' +
    BYTE_TO_HEX[bytes[8]] +
    BYTE_TO_HEX[bytes[9]] +
    '-' +
    BYTE_TO_HEX[bytes[10]] +
    BYTE_TO_HEX[bytes[11]] +
    BYTE_TO_HEX[bytes[12]] +
    BYTE_TO_HEX[bytes[13]] +
    BYTE_TO_HEX[bytes[14]] +
    BYTE_TO_HEX[bytes[15]]
  );
}

export function createRandomID() {
  const cryptoRef = globalThis.crypto;
  if (typeof cryptoRef?.randomUUID === 'function') {
    return cryptoRef.randomUUID();
  }
  if (typeof cryptoRef?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    cryptoRef.getRandomValues(bytes);
    return uuidFromRandomBytes(bytes);
  }
  return `id-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export function createPrefixedRandomID(prefix: string) {
  return `${prefix}-${createRandomID()}`;
}
